import React from "react";
import { Box } from "@mui/material";
const PageContent = ({ children, sx, hasBottomAction = false, }) => {
    return (React.createElement(Box, { sx: Object.assign({ flex: 1, minHeight: 0, overflow: "auto", display: "flex", flexDirection: "column", pt: 1.5, pb: {
                xs: hasBottomAction
                    ? "calc(130px + env(safe-area-inset-bottom))"
                    : "calc(62px + env(safe-area-inset-bottom))",
                sm: hasBottomAction
                    ? "calc(130px + env(safe-area-inset-bottom))"
                    : "calc(62px + env(safe-area-inset-bottom))",
                lg: 0,
            }, pr: { xs: 1.5, sm: 2, lg: 3 } }, sx) }, children));
};
export default PageContent;
